
const Pacijent = function(DS) {
    return DS.defineResource({
        name: 'Pacijent',
        endpoint: '/pacijenti',
        relations: {
            // hasMany uses "localField" and "localKeys" or "foreignKey"
            hasMany: {
                Pregled: {
                    // localField is for linking relations
                    // user.comments -> array of comments of the user
                    localField: 'pregledi',
                    // foreignKey is the "join" field
                    // the name of the field on a comment that points to its parent user
                    foreignKey: 'pacijent'
                }
            },
        }
    });
};

Pacijent.$inject = ['DS'];

export {Pacijent};



// WEBPACK FOOTER //
// ./app/models/pacijent.js